module.exports = __webpack_public_path__ + "img/1bg.d532ba28.png";